<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="modal fade" id="costumModalopsi" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" style="height: auto;min-width: 95vw;">
                    <div class="modal-header bg-yellow">
                        <h4 class="modal-title">Opsi {{ mode }} Data</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <p>
                        <div class="row">
                            <input type="hidden" class="form-control form-control-sm" id="mode" name="mode"
                                placeholder="mode" v-model="mode">
                            <input type="hidden" class="form-control form-control-sm" id="opsi" name="opsi"
                                placeholder="opsi" v-model="opsi">
                            <input type="hidden" class="form-control form-control-sm" id="id_parent" name="id_parent"
                                placeholder="id_parent" v-model="id_parent">
                            <input type="hidden" class="form-control form-control-sm" id="id" name="id" placeholder="id"
                                v-model="id">
                            <input type="hidden" class="form-control form-control-sm" id="level" name="level"
                                placeholder="level" v-model="level">
                            <input type="hidden" class="form-control form-control-sm" id="urutlevel" name="urutlevel"
                                placeholder="urutlevel" v-model="urutlevel">
                            <div class="col-sm-12">
                                <label>Indikator <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="nama" name="nama"
                                        placeholder="Indikator" v-model="nama">
                                </div>
                            </div>
                            <div class="col-sm-12"
                                v-if="level != 'Outcome' && level != 'Output' && level != 'Komponen'">
                                <label>Baseline <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="baseline"
                                        name="baseline" placeholder="Baseline" v-model="baseline">
                                </div>
                            </div>
                            <div class="col-sm-12"
                                v-if="level != 'Outcome' && level != 'Output' && level != 'Komponen'">
                                <label>Satuan Baseline<small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="satuan" name="satuan"
                                        placeholder="Satuan Baseline" v-model="satuan">
                                </div>
                            </div>
                            <div class="col-sm-12"
                                v-if="level != 'Outcome' && level != 'Output' && level != 'Komponen'">
                                <label>Target <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="target" name="target"
                                        placeholder="Target" v-model="target">
                                </div>
                            </div>
                            <div class="col-sm-12"
                                v-if="level != 'Outcome' && level != 'Output' && level != 'Komponen'">
                                <label>Satuan Target <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="satuan_target"
                                        name="satuan_target" placeholder="Satuan Target" v-model="satuan_target">
                                </div>
                            </div>
                            <div class="col-sm-12"
                                v-if="level != 'Outcome' && level != 'Output' && level != 'Komponen'">
                                <label>Source Indikator <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="source_indikator"
                                        name="source_indikator" placeholder="Source Indikator"
                                        v-model="source_indikator">
                                </div>
                            </div>
                            <div class="col-sm-12"
                                v-if="level != 'Outcome' && level != 'Output' && level != 'Komponen'">
                                <label>Responsibility <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="responsibility"
                                        name="responsibility" placeholder="Responsibility" v-model="responsibility">
                                </div>
                            </div>
                            <div class="col-sm-12"
                                v-if="level != 'Outcome' && level != 'Output' && level != 'Komponen'">
                                <label>Progress <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="progress"
                                        name="progress" placeholder="Progress" v-model="progress">
                                </div>
                            </div>
                            <div class="col-sm-12"
                                v-if="level != 'Outcome' && level != 'Output' && level != 'Komponen'">
                                <label>Remarks <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" id="remarks" name="remarks"
                                        placeholder="Remarks" v-model="remarks">
                                </div>
                            </div>
                            <div class="col-sm-12" v-if="level != 'Outcome'">
                                <label>Urutan Data <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i
                                                class="fab fa-creative-commons-share"></i></span>
                                    </div>
                                    <input type="number" class="form-control form-control-sm" id="urut" name="urut"
                                        placeholder="Urutan Data" v-model="urut">
                                </div>
                            </div>
                        </div>
                        </p>
                    </div>
                    <div class="modal-footer" style="position: relative;height: 80px !important;">
                        <div class="col-sm-12 text-center">
                            <button type="button" class="btn btn-primary btn-sm lebar2 text-white" @click="simpan()">
                                <i class="fas fa-plus-square"></i>
                                Simpan
                            </button>
                            <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal">
                                <i class="far fa-times-circle"></i>
                                Tutup
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Result Framework</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">HOME </a></li>
                                <li class="breadcrumb-item active">Result Framework</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                    <div class="col-sm-12 float-left pb-2">&nbsp;</div>
                                    <div class="col-sm-12 float-left pb-2">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian">
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata" style="font-size: small;">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;" rowspan="2">Opsi</th>
                                                    <th style="width: 150px;" rowspan="2">Target<br>Indikator</th>
                                                    <th style="width: 100px;" rowspan="2">Baseline</th>
                                                    <th style="width: 100px;" rowspan="2">End<br>Target<br>Value</th>
                                                    <th style="width: 150px;" rowspan="2">Source<br>(baseline/target)
                                                    </th>
                                                    <th style="width: 100px;" rowspan="2">Responsibility</th>
                                                    <th style="width: 150px;" rowspan="2">Progres</th>
                                                    <th style="width: 150px;" rowspan="2">Remarks</th>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in filteredKataData" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center" :class="datalist.class">
                                                            <div class="btn-group" v-if="datalist.level == 'Outcome'">
                                                                <button type="btn btn-primary3 lebar4 btn-sm text-white"
                                                                    style="font-size: smaller !important;"
                                                                    class="btn btn-danger3 btn-sm dropdown-toggle dropdown-icon text-white"
                                                                    data-toggle="dropdown" aria-expanded="false">
                                                                    <i class="fas fa-plus"></i>
                                                                    &nbsp;&nbsp;Tambah&nbsp;&nbsp;
                                                                    <span class="sr-only"> Toggle Dropdown</span>
                                                                </button>
                                                                <div class="dropdown-menu" role="menu"
                                                                    style="font-size: smaller !important;">
                                                                    <a class="dropdown-item" href="javascript:void(0)"
                                                                        @click="prosesdata('Rincian Outcome', null, datalist.id, 2, '', '', '', '', '', '', '', '', '', '', '', '', 'Tambah')">Rincian
                                                                        Outcome</a>
                                                                    <a class="dropdown-item" href="javascript:void(0)"
                                                                        @click="prosesdata('Output', null, datalist.id, 3, '', '', '', '', '', '', '', '', '', '', '', '', 'Tambah')">
                                                                        Output</a>
                                                                </div>
                                                            </div>
                                                            <div class="btn-group" v-if="datalist.level == 'Output'">
                                                                <button type="btn btn-primary3 lebar4 btn-sm text-white"
                                                                    style="font-size: smaller !important;"
                                                                    class="btn btn-danger3 btn-sm dropdown-toggle dropdown-icon text-white"
                                                                    data-toggle="dropdown" aria-expanded="false">
                                                                    <i class="fas fa-plus"></i>
                                                                    &nbsp;&nbsp;Tambah&nbsp;&nbsp;
                                                                    <span class="sr-only"> Toggle Dropdown</span>
                                                                </button>
                                                                <div class="dropdown-menu" role="menu"
                                                                    style="font-size: smaller !important;">
                                                                    <a class="dropdown-item" href="javascript:void(0)"
                                                                        @click="prosesdata('Komponen', null, datalist.id, 4, '', '', '', '', '', '', '', '', '', '', '', '', 'Tambah')">Komponen</a>
                                                                </div>
                                                            </div>
                                                            <div class="btn-group" v-if="datalist.level == 'Komponen'">
                                                                <button type="btn btn-primary3 lebar4 btn-sm text-white"
                                                                    style="font-size: smaller !important;"
                                                                    class="btn btn-danger3 btn-sm dropdown-toggle dropdown-icon text-white"
                                                                    data-toggle="dropdown" aria-expanded="false">
                                                                    <i class="fas fa-plus"></i>
                                                                    &nbsp;&nbsp;Tambah&nbsp;&nbsp;
                                                                    <span class="sr-only"> Toggle Dropdown</span>
                                                                </button>
                                                                <div class="dropdown-menu" role="menu"
                                                                    style="font-size: smaller !important;">
                                                                    <a class="dropdown-item" href="javascript:void(0)"
                                                                        @click="prosesdata('Rincian', null, datalist.id, 5, '', '', '', '', '', '', '', '', '', '', '', '', 'Tambah')">Rincian</a>
                                                                </div>
                                                            </div>
                                                            <button type="button"
                                                                class="btn btn-primary3 lebar4 btn-sm text-white"
                                                                style="font-size: smaller !important;"
                                                                @click="prosesdata(datalist.level, datalist.id, datalist.id_parent, datalist.urutlevel, datalist.komponen, datalist.subkomponen, datalist.nama, datalist.baseline, datalist.satuan, datalist.target, datalist.satuan_target, datalist.source_indikator, datalist.responsibility, datalist.progress, datalist.remarks, datalist.urut, 'Edit')"
                                                                data-toggle="tooltip" data-placement="left"
                                                                title="Edit data.."><i class="fas fa-edit"></i>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit
                                                                Data</button>
                                                            <button type="button"
                                                                class="btn btn-danger lebar4 btn-sm text-white"
                                                                style="font-size: smaller !important;"
                                                                @click="hapus(datalist.id)" data-toggle="tooltip"
                                                                data-placement="left" title="Hapus data.."><i
                                                                    class="fas fa-trash-alt"></i>
                                                                &nbsp;&nbsp;Hapus Data</button>
                                                        </td>
                                                        <td :colspan="datalist.colspan" :class="datalist.class"
                                                            v-if="datalist.level == 'Outcome' || datalist.level == 'Output' || datalist.level == 'Komponen' || datalist.level == 'Rincian'">
                                                            <span v-html="datalist.nama"></span>
                                                        </td>
                                                        <td :colspan="datalist.colspan" :class="datalist.class"
                                                            v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen' && datalist.level != 'Rincian'">
                                                            <span v-html="datalist.nama"></span>
                                                        </td>
                                                        <td :colspan="datalist.colspan" class="text-center"
                                                            :class="datalist.class"
                                                            v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                                            <span v-html="datalist.baseline"></span> <span
                                                                v-html="datalist.satuan"></span>
                                                        </td>
                                                        <td :colspan="datalist.colspan" class="text-center"
                                                            :class="datalist.class"
                                                            v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                                            <span v-html="datalist.target"></span> <span
                                                                v-html="datalist.satuan_target"></span>
                                                        </td>
                                                        <td :colspan="datalist.colspan"
                                                            v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                                            <span v-html="datalist.source_indikator"></span>
                                                        </td>
                                                        <td :colspan="datalist.colspan" class="text-center"
                                                            :class="datalist.class"
                                                            v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                                            <span v-html="datalist.responsibility"></span>
                                                        </td>
                                                        <td :colspan="datalist.colspan" :class="datalist.class"
                                                            v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                                            <span v-html="datalist.progress"></span>
                                                        </td>
                                                        <td :colspan="datalist.colspan" :class="datalist.class"
                                                            v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                                            <span v-html="datalist.remarks"></span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    <td class="text-center">
                                                        <button type="button" class="btn btn-danger3 btn-sm text-white"
                                                            @click="prosesdata('Outcome', null, null, '1', '', '', '', '', '', '', '', '', '', '', '', '1', 'Tambah')"
                                                            data-toggle="tooltip" data-placement="left"
                                                            title="Tambah Outcome.."
                                                            style="font-size: smaller !important;">
                                                            <i class="fas fa-plus"></i> Tambah Outcome
                                                        </button>
                                                    </td>
                                                    <td colspan="6">Data masih kosong</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import xlsx from 'xlsx/dist/xlsx.full.min';
import readXlsxFile from 'read-excel-file';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            datapesan: '',
            datamaster: [],
            carikata: '',
            colspan: 0,
            datatahun: [],
            tempheader: [],
            tempdata: [],
            tempjumlah: 0,
            tempjumlahdb: 0,
            folder_excel: process.env.VUE_APP_URL_API + 'parastapainnovation_excel-DownloadExcel?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
            tempexcel: [],
            ekportexcel: [],
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
            level: 1,
            id: null,
            id_parent: null,
            urutlevel: 1,
            komponen: '',
            subkomponen: '',
            nama: '',
            baseline: '',
            satuan: '',
            target: '',
            satuan_target: '',
            source_indikator: '',
            responsibility: '',
            progress: '',
            remarks: '',
            urut: 1,
            mode: '',
            validasi: false,
        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        prosesdata(level, id, id_parent, urutlevel, komponen, subkomponen, nama, baseline, satuan, target, satuan_target, source_indikator, responsibility, progress, remarks, urut, mode) {
            this.level = level;
            this.id = id;
            this.id_parent = id_parent;
            this.urutlevel = urutlevel;
            this.komponen = komponen;
            this.subkomponen = subkomponen;
            this.nama = nama;
            this.baseline = baseline;
            this.satuan = satuan;
            this.target = target;
            this.satuan_target = satuan_target;
            this.source_indikator = source_indikator;
            this.responsibility = responsibility;
            this.progress = progress;
            this.remarks = remarks;
            this.urut = urut;
            this.mode = mode;
            //alert(kode);
            $('#costumModalopsi').modal('show');
        },
        validasidata() {
            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if ((this.nama == '') || (this.nama == null) || (this.nama == undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('nama').focus();
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            this.validasi = true;
            return;
        },
        simpan() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            //alert(this.id);
            var fd = new FormData();
            fd.append("mode", this.mode);
            fd.append("project_id", this.project_id);
            fd.append("id", this.id);
            fd.append("level", this.level);
            fd.append("id_parent", this.id_parent);
            fd.append("urutlevel", this.urutlevel);
            fd.append("komponen", this.komponen);
            fd.append("subkomponen", this.subkomponen);
            fd.append("nama", this.nama);
            fd.append("baseline", this.baseline);
            fd.append("satuan", this.satuan);
            fd.append("target", this.target);
            fd.append("satuan_target", this.satuan_target);
            fd.append("source_indikator", this.source_indikator);
            fd.append("responsibility", this.responsibility);
            fd.append("progress", this.progress);
            fd.append("remarks", this.remarks);
            fd.append("urut", this.urut);
            fd.append("createdby", JSON.parse(localStorage.getItem("usistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_dmf-Add", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/PDOIOS");
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        hapus(id) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#005c95",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { id: id, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("usistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("parastapainnovation_dmf-Delete", data).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.replace("/PDOIOS");
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovation_dmf-GetData?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datatahun = [];
                    this.datatahun = Response.data.tahun;
                    this.colspan = Response.data.jumlahtahun;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                    }
                    else {
                        this.datamaster = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildata();
    }
}
</script>
<style></style>